// extracted by mini-css-extract-plugin
module.exports = {"title":"notFound_title__XdqOz","b":"notFound_b__lV6jh","p":"notFound_p__aOJAX","img":"notFound_img__25nDp"};